import { KeenSliderHooks, KeenSliderInstance } from 'keen-slider/react';
import { MutableRefObject } from 'react';

import { Arrow } from './Arrow/Arrow';

interface Props {
  loaded: boolean;
  currentSlide: number;
  sliderInstanceRef: MutableRefObject<KeenSliderInstance<{}, {}, KeenSliderHooks> | null>;
}

export function Arrows({ loaded, currentSlide, sliderInstanceRef }: Props) {
  if (loaded && sliderInstanceRef.current)
    return (
      <>
        <Arrow
          disabled={currentSlide === 0}
          isArrowDirectionLeft
          onClick={(e: any) => e.stopPropagation() || sliderInstanceRef.current?.prev()}
        />

        <Arrow
          disabled={currentSlide === sliderInstanceRef.current.track.details.slides.length - 1}
          onClick={(e: any) => e.stopPropagation() || sliderInstanceRef.current?.next()}
        />
      </>
    );
}
